import { query } from "./strapi";
import apiCache from './apiCache';

export function getCategoryTree() {
  const CACHE_KEY = 'categories/tree';
  const TWO_HOURS = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
  
  // Check cache first
  const cachedData = apiCache.get(CACHE_KEY);
  if (cachedData) {
    return Promise.resolve(cachedData);
  }

  return query("categories/tree")
    .then((res) => {
      const categoryData = res?.data || []; // Return the data directly or an empty array if null
      
      // Store in cache with 2-hour expiration
      apiCache.set(CACHE_KEY, categoryData, TWO_HOURS);
      
      return categoryData;
    })
    .catch((err) => {
      console.error("Error fetching category tree:", err);
      return []; // Return an empty array in case of error
    });
}

// Function to refresh category tree data
export function refreshCategoryTree() {
  apiCache.clear('categories/tree');
  return getCategoryTree(); // Re-fetch from API
}
